// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"ecc88461","11":"a4d7a714","30":"542d20ef","210":"acc42ec1","344":"863ea56a","438":"8f109537","642":"7914b5e0","829":"a15e4b51"}[chunkId] + ".chunk.js";
};